import script from "./IncidentCreateUpdateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./IncidentCreateUpdateForm.vue?vue&type=script&setup=true&lang=js"

import "./IncidentCreateUpdateForm.vue?vue&type=style&index=0&id=0ee7ef38&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee7ef38"]])

export default __exports__